import React from "react";
import { Form, Row, Col, Badge } from "react-bootstrap";
import Select from "react-select";
import type { BatchListItem } from "../../../../api/academyEnrolments/enrolmentsService";

interface BatchSectionProps {
  batchList: BatchListItem[];
  selectedBatch: BatchListItem | null;
  loadingBatches: boolean;
  onBatchSelect: (b: BatchListItem) => void;
  disabled?: boolean;
  sectionNumber?: number;
}

const BatchSection: React.FC<BatchSectionProps> = ({
  batchList,
  selectedBatch,
  loadingBatches,
  onBatchSelect,
  disabled,
  sectionNumber = 6,
}) => {
  const batchOptions = batchList.map((b) => ({
    value: b._id,
    label: b.batchName,
    batch: b,
  }));

  return (
    <div className="enrolment-form-section">
      <h6 className="enrolment-section-title">
        <span className="enrolment-section-number">{sectionNumber}</span>
        Batch
      </h6>

      <Row className="g-3">
        <Col xs={12} md={6}>
          <Form.Label className="mb-1 text-muted" style={{ fontSize: 12 }}>
            Batch *
          </Form.Label>
          {disabled ? (
            <div className="enrolment-readonly-field-wrapper">
              <Form.Control
                readOnly
                value={selectedBatch?.batchName ?? "—"}
                style={{ pointerEvents: "none" }}
              />
            </div>
          ) : (
            <Select
              classNamePrefix="react-select"
              options={batchOptions}
              isLoading={loadingBatches}
              isDisabled={disabled}
              value={
                selectedBatch
                  ? { value: selectedBatch._id, label: selectedBatch.batchName, batch: selectedBatch }
                  : null
              }
              onChange={(opt) => opt && onBatchSelect(opt.batch)}
              placeholder="Select batch..."
              formatOptionLabel={(opt) => (
                <div>
                  <div style={{ fontWeight: 500 }}>{opt.label}</div>
                  {opt.batch && (
                    <div style={{ fontSize: 11, color: "#888" }}>
                      Age: {opt.batch.ageCategory} &middot; Slot type: {opt.batch.slotType}
                    </div>
                  )}
                </div>
              )}
            />
          )}
        </Col>

        {selectedBatch && (
          <Col xs={12} md={4} className="d-flex align-items-end">
            <div>
              <div className="text-muted mb-1" style={{ fontSize: 11 }}>Age Category</div>
              <Badge bg="light" text="dark" className="border">
                {selectedBatch.ageCategory}
              </Badge>
            </div>
          </Col>
        )}
      </Row>

      {selectedBatch && selectedBatch.trainingDays?.length > 0 && (
        <div className="mt-2 text-muted" style={{ fontSize: 12 }}>
          <i className="ri-calendar-line me-1" />
          Training days:{" "}
          {selectedBatch.trainingDays
            .map((d) => d.charAt(0).toUpperCase() + d.slice(1))
            .join(", ")}
        </div>
      )}
    </div>
  );
};

export default BatchSection;
